import React from 'react';
import { useTranslation } from 'react-i18next';
import BzmIcon from '../../../../../components/icons/BzmIcon';

interface OutdatedRequestProps {
  refreshRequestsHandler: () => void;
}

/**
 * Placeholder for showing outdated request info.
 * @constructor
 */
const OutdatedRequest = (props: OutdatedRequestProps) => {
  const { t } = useTranslation('analytics');
  return (
    <div style={{ height: '400px' }}>
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
        <div className="text-center">
          <BzmIcon variant={'icon-bzm-sync'} className={'icon-xlg'} style={{ color: '#BFBFBF', fontSize: '120px' }} />
          <p className="mt-2">
            {t('outdatedRequest.outdatedRequest')} <br />
            {t('outdatedRequest.clickRefresh')}
          </p>

          <button onClick={props.refreshRequestsHandler} className="btn btn-primary">
            {t('outdatedRequest.refreshList')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OutdatedRequest;
